import Blue from "~/core";
import Splide from "@splidejs/splide"

new Blue({
  name: "descriptiveCarousel",
  selector: ".descriptive-carousel",
  setup(descriptiveCarousel) {

      var shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
      if (shouldSetTimeout) {
          updateSplideMethodList({
              initDescriptiveCarouselSplide
          });

      } else {
          initDescriptiveCarouselSplide();
      }

  },
}
);

  function initDescriptiveCarouselSplide() {

    var splideElement = document.querySelector('.descriptive-carousel.splide');

    if (splideElement) {
      const descriptiveCarouselSplide = new Splide(splideElement, {
        type: 'loop',
        pagination: false,
      });
      descriptiveCarouselSplide.mount();
    }
  }

  function updateSplideMethodList(functionList) {
    if(window.splideMethods)
    {
      Object.assign(window.splideMethods, functionList);
    }
    else {
      window.splideMethods = functionList;
    }
  }
